/**
 * Sidebar configuration constants
 * Single source of truth for sidebar dimensions
 */

export const SIDENAV_WIDTHS = {
  collapsed: '80px',
  expanded: '200px',
} as const;
